import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function SydneyMarathon5kmMain() {
  const offerId = REWARD_OFFERING.sydneyMarathon5km;

  return (
    <CompetitionPage
      offerId={offerId}
    />
  );
}

export default SydneyMarathon5kmMain;
